/*
 * Ajax filtering for resources
 */

// eslint-disable-next-line no-unused-vars
import { fetch } from '../../util/_fetch';

(function($) {
    // toggle the drop downs appearing
    const resourceSearch = '.rs-resource-search';
    $(resourceSearch).on('click', '.rs-resource-search__input-display__toggle', function() {
        $(this).parent().toggleClass('active');
        $(this).siblings().slideToggle(300);
    });

    // on select change, update the actual select, and the visible one too
    const dispSelect = '.rs-resource-search__select-display';
    const funcSelect = '.rs-resource-search__select-functional';
    $(resourceSearch).on('click', dispSelect + ' li', function() {
        const valSelect = $(this).data('topic');
        $(this).closest(dispSelect).siblings(funcSelect).val(valSelect).trigger('change');
        $(this).closest(dispSelect).removeClass('active');
        const displayText = $(this).text();
        $(this).closest(dispSelect).find('.rs-resource-search__input-display__toggle').text(displayText);
    });

    // load more functionality
    $('.j-loadmore').on('click', '.j-loadmore--button', function(e) {
        // Setup _this variable and prevent default behaviour
        const _this = $(this);
        e.preventDefault();

        // Exit if in progress class is added
        if (_this.hasClass('in-progress')) return;

        // Add in progress class to prevent multiple clicks
        _this.addClass('in-progress');

        // Get the container element
        const container = _this.parents('.j-loadmore');

        // Get a list of classes for the object to use to find it in the results
        let containerClasses = '.' + container.attr('class');
        containerClasses = containerClasses.split(' ').join('.');

        // Get the page URL to fetch
        const url = $(this).attr('href');

        // Fetch the URL and replace/append the content
        window._fetch.callbackContent(url, function(result) {
            // Get results object
            const results = $(result);
            // Remove in progress class
            _this.removeClass('in-progress');
            // Add the posts from the results to the posts on the page
            container.find('.j-loadmore--posts').append(results.find(containerClasses).find('.j-loadmore--posts').html());
            // Replace the pagination on the page with the pagination on the fetched page
            container.find('.j-loadmore--pagination').html(results.find(containerClasses).find('.j-loadmore--pagination').html());
        });
    });

    function getFilterValues(filterClass) {
        const valueArray = [];
        $.each($(filterClass + ' input:checked'), function() {
            valueArray.push($(this).val());
        });
        return valueArray;
    }

    // redirect functionality
    const searchForm = $('.rs-resource-search__form');
    const redirectCheck = searchForm.data('redirect');
    const redirectURL = searchForm.data('redirect-link');
    const container = $('.j-ajax--container');

    function getFilteredURL() {
        const baseURL = redirectCheck ? redirectURL : container.data('permalink');
        const search = $('#search').val();
        const topic = $('.filter_class_one').val();
        const resourceType = getFilterValues('.filter_class_two');
        const params = new URLSearchParams({
            ...(search) && { search },
            ...(topic) && { 'filter-topic': topic },
            ...(resourceType.length > 0) && { 'filter-resource-type': resourceType.join(',') },
        });
        return params.size > 0 ? `${baseURL}?${params.toString()}` : baseURL;
    }

    const searchInput = $('#search');
    const clearButton = $('.rs-resource-search__form__input-container');
    const searchButton = $('.rs-resource-search__form__keywords-container button');

    searchInput.on('focus', function() {
        if ($(this).val()) {
            clearButton.addClass('search-active');
        }
    });

    searchButton.on('click', () => window.location.assign(getFilteredURL()));

    searchInput.on('input', function() {
        if ($(this).val().length === 0) {
            clearButton.removeClass('search-active');
            searchButton.prop('disabled', true);
        } else {
            clearButton.addClass('search-active');
            searchButton.prop('disabled', false);
        }
    });

    searchForm.on('submit', () => window.location.assign(getFilteredURL()));

    const focusSearchOnKeywords = () => {
        const length = searchInput.val().length;
        if (length > 0) {
            searchInput.trigger('focus');
            searchInput[0].setSelectionRange(length, length);
        }
    };

    focusSearchOnKeywords();

    // Handles search form submission (entering a search term or changing the topic or resource types dropdowns).
    searchForm.submit(e => e.preventDefault());
    $('.j-ajax').on('change', '.j-ajax--select,.j-ajax--filter .rs-resource-search__checkbox-display input', () => window.location.assign(getFilteredURL()));

    // click the X on active type tags
    $('.j-loadmore--title').on('click', '.rs-resource-hub__banner__tagged-with__type', function() {
        const thisType = $(this).data('type');
        $('.filter_class_two').find('#' + thisType).siblings('label').click();
    });

    // mobile functionality
    $(resourceSearch).on('click', '.rs-resource-search__mobile-toggle__search', function() {
        clearButton.addClass('search-active');
    });
    $(resourceSearch).on('click', '.rs-resource-search__form__input-container__close', function() {
        clearButton.removeClass('search-active');
        if ($(window).width() >= 768) {
            searchInput.val('');
            searchButton.prop('disabled', true);
        }
    });

    $(resourceSearch).on('click', '.rs-resource-search__mobile-toggle__filters', function() {
        $(this).toggleClass('active');
        $('.rs-resource-search__input-container').toggleClass('filter-active');
    });
})(jQuery); // Fully reference jQuery after this point.
